let abortController = new AbortController();

export const getAbortSignal = () => {
  return abortController.signal;

};

export const abortAllRequests = () => {
  abortController.abort();
  abortController = new AbortController();
};

export const resetAbortController = () => {
  abortController = new AbortController();
};